@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-6 mt-2">
      <select-jurisdiction-types-field
        [selectFormControl]="getJurisdictionTypeSelect()"
        label="Type"
        />
    </div>
    <div class="col-sm-6 mt-2">
      <input-field type="text" [inputFormControl]="getJurisdictionCodeInput()" label="Code" placeholder="Code" />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 mt-2">
      <input-field type="text" [inputFormControl]="getJurisdictionNameInput()" label="Name" placeholder="Name" />
    </div>

    <div class="col-sm-6 mt-2">
      <language-client [radioFormControl]="getJurisdictionLanguageInput()" label="Language"
        (languageChange)="getJurisdictionLanguageInput().setValue($event)" />
    </div>

  </div>

  <div class="text-center mt-4">
    <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
      Save
    </button>
  </div>
</form>